import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state() {
        return {
            tasks: [
                'Trigger Identification',
                'Poll Question Generation',
                'Sentiment Analysis for Code-Switched Text',
                'User Profile Modeling',
                'Social Emotions to Online Topics'],
            isLogin: false,
            phaseTwoStatus: ['Fail to Upload', 'Uploaded', 'Fail to transmit', 'Transmitted', 'Unziped', 'Implemented'],
            order: ['1st', '2nd', '3rd'],
        }
    },
    getters: {
        getLoginStatus(state) {
            return state.isLgoin;
        },
    },
    mutations: {
        addLoginInfo(state) {
            state.isLogin = true;
        },
        removeLoginInfo(state) {
            state.isLogin = false;
        }
    },
    actions: {
        addLoginInfo(state) {
            state.isLogin = true;
        },
    },
    modules: {}
})

export default store
